import React, { createContext, useContext, useState } from 'react';

export interface ContextProps {
  context: {
    isCaseStudy: boolean;
    setIsCaseStudy: (arg: boolean) => void;
  };
}

const GlobalStateContext = createContext<ContextProps>({
  context: {
    isCaseStudy: false,
    setIsCaseStudy: () => {},
  },
});

export const GlobalProvider: React.FC = ({ children }) => {
  const [isCaseStudy, setIsCaseStudy] = useState<boolean>(false);

  const state = {
    context: {
      setIsCaseStudy,
      isCaseStudy,
    },
  };

  return (
    <GlobalStateContext.Provider value={state}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalStateContext = () => useContext(GlobalStateContext);
